import { Link, useLocation } from 'react-router-dom'
import { FaArrowRight } from 'react-icons/fa6'
import { motion } from 'framer-motion'
import { getPageBreadcrumbTitle } from '../../data/pageBreadcrumbData'
import PageBreadcrumb from './PageBreadcrumb'

function HeroCta({ cta, variant }) {
  if (!cta) return null

  const className = `split-page-hero__btn split-page-hero__btn--${variant}`
  const content = (
    <>
      {cta.label}
      <FaArrowRight aria-hidden="true" />
    </>
  )

  if (cta.to.startsWith('#') || cta.to.startsWith('http')) {
    return (
      <a className={className} href={cta.to}>
        {content}
      </a>
    )
  }

  return (
    <Link className={className} to={cta.to}>
      {content}
    </Link>
  )
}

function SplitPageHero({
  id,
  eyebrow,
  title,
  description,
  image,
  imageAlt,
  imagePosition = '72% center',
  breadcrumbTitle,
  primaryCta,
  secondaryCta,
  children,
}) {
  const { pathname } = useLocation()
  const resolvedBreadcrumbTitle = breadcrumbTitle ?? getPageBreadcrumbTitle(pathname)

  return (
    <section className="split-page-hero" aria-labelledby={id}>
      <div className="split-page-hero__visual" aria-hidden="true">
        <img
          src={image}
          alt={imageAlt}
          loading="eager"
          fetchPriority="high"
          style={{ objectPosition: imagePosition }}
        />
        <div className="split-page-hero__visual-mask" />
      </div>
      <span className="split-page-hero__pattern" aria-hidden="true" />

      <div className="container corp-container split-page-hero__container">
        <motion.div
          className="split-page-hero__content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, ease: 'easeOut' }}
        >
          {resolvedBreadcrumbTitle || eyebrow ? (
            <div className="split-page-hero__meta">
              {resolvedBreadcrumbTitle ? (
                <PageBreadcrumb
                  title={resolvedBreadcrumbTitle}
                  className="page-breadcrumb--pill"
                />
              ) : null}
              {eyebrow ? <span className="split-page-hero__eyebrow">{eyebrow}</span> : null}
            </div>
          ) : null}
          <h1 id={id} className="split-page-hero__title">
            {title}
          </h1>
          <span className="split-page-hero__accent" aria-hidden="true" />
          {description ? <p className="split-page-hero__lead">{description}</p> : null}
          {primaryCta || secondaryCta ? (
            <div className="split-page-hero__actions">
              <HeroCta cta={primaryCta} variant="primary" />
              <HeroCta cta={secondaryCta} variant="outline" />
            </div>
          ) : null}
        </motion.div>
      </div>

      {children}
    </section>
  )
}

export default SplitPageHero
